import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { type GridProps } from './types';
import MUIGrid from '@mui/material/Grid';
const Grid = React.forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <MUIGrid {...props} ref={ref}>{props.children}</MUIGrid>;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export default Grid;
export { Grid };
export type { GridProps } from './types';